<template>
  <div class="new-task">
    <div class="header">
      <div
        class="go-back"
        @click="goBack"
      >
        <mk-iconfont
          icon-class="left"
          class="icon"
        ></mk-iconfont>
      </div>
      <div class="txt">
        {{ titleMsg }}
      </div>
    </div>
    <div class="search">
      <div class="date">
        <span class="icon">*&nbsp;</span>
        <span class="txt">执行时间：</span>
        <mk-date-picker
          v-if="handleShow"
          v-model="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        />
        <span
          v-else
          class="date-txt"
        >{{ date }}</span>
      </div>
      <div class="btn">
        <mk-button-biz
          v-if="handleShow"
          class="new-btn"
          type="primary"
          icon="el-icon-plus"
          @click="addMaterial"
        >
          添加分享内容
        </mk-button-biz>
      </div>
    </div>
    <div class="content">
      <ul
        v-if="list.length > 0"
        class="list"
      >
        <li
          v-for="(item,index) in list"
          :key="index"
          class="list-item"
        >
          <div class="list-item-main">
            <div class="index">
              {{ index + 1 }}
            </div>
            <div class="content-c">
              <div class="content-c-t">
                分享文章<span class="title">《{{ item.title }}》</span>
              </div>
              <div class="content-c-tag">
                <span>标签：</span>
                <mk-popover
                  placement="right-start"
                  trigger="hover"
                  popper-class="task-list-add-tag-popper"
                  :disabled="item.tags && item.tags.length <= 3"
                >
                  <div
                    slot="reference"
                    class="tag-group"
                  >
                    <div
                      v-if="item.tags && item.tags.length > 3"
                      class="tag-group-item"
                    >
                      <mk-tag
                        class="tag-item"
                        :title="item.tags[0].name"
                      >
                        {{ handleStr(item.tags[0].name) }}
                      </mk-tag>
                      <mk-tag
                        class="tag-item"
                        :title="item.tags[1].name"
                      >
                        {{ handleStr(item.tags[1].name) }}
                      </mk-tag>
                      <mk-tag
                        class="tag-item"
                        :title="item.tags[2].name"
                      >
                        {{ handleStr(item.tags[2].name) }}
                      </mk-tag>
                      <span class="tag-info">等{{ item.tags.length }}个标签</span>
                    </div>
                    <div
                      v-else
                      class="tag-group-item"
                    >
                      <mk-tag
                        v-for="(itemC,indexC) in item.tags"
                        :key="indexC"
                        class="tag-item"
                        :title="itemC.name"
                      >
                        {{ handleStr(itemC.name) }}
                      </mk-tag>
                    </div>
                  </div>
                  <div
                    class="all-tags"
                    style="max-width:200px;"
                  >
                    <mk-tag
                      v-for="(itemC,indexC) in item.tags"
                      :key="indexC"
                      class="tag-item"
                      style="margin:5px 0 0 5px;"
                    >
                      {{ itemC.name }}
                    </mk-tag>
                  </div>
                </mk-popover>
              </div>
            </div>
          </div>
          <div class="list-item-handle">
            <mk-button-biz
              v-if="handleShow"
              type="text"
              size="small"
              @click="edit(index, item._id)"
            >
              编辑
            </mk-button-biz>
            <mk-button-biz
              v-if="handleShow"
              type="text"
              size="small"
              @click="remove(index, item._id)"
            >
              移除
            </mk-button-biz>
          </div>
        </li>
      </ul>
    </div>
    <div
      v-if="handleShow"
      class="handle"
    >
      <mk-button-biz @click="goBack">
        取消
      </mk-button-biz>
      <mk-button-biz
        type="primary"
        @click="confirm"
      >
        确认
      </mk-button-biz>
    </div>
    <material
      v-if="show"
      :show="show"
      :state="state"
      init-type="article"
      :init-list="list"
      :selected-id="selectedId"
      @add="addMaketingData"
      @cancel="cancel"
      @replace="replaceMaketingData"
    ></material>
  </div>
</template>
<script>
import material from './material.vue'
import dayjs from 'dayjs'
import { BIZAPIS } from '../../../api'
export default {
  components: {
    material
  },
  data () {
    return {
      date: '',
      show: false,
      state: 0,
      list: [],
      selectedId: '',
      editIndex: 0,
      removeIndex: 0,
      handleShow: true,
      titleMsg: '创建传播任务'
    }
  },
  computed: {
    formData () {
      let arr = []
      this.list.forEach((item, index) => {
        arr[index] = {
          _id: item._id,
          type: item.materialType || item.type
        }
      })
      return arr
    }
  },
  watch: {
    date (val) {
      if (!this.$route.query.id) {
        let nowDate = new Date(
          dayjs(new Date()).format('YYYY-MM-DD') + ' 00:00:00'
        ).getTime()
        if (new Date(val).getTime() < nowDate) {
          this.$message({
            type: 'error',
            message: '执行时间必须大于当下时间',
            showClose: true
          })
          this.date = ''
        }
      } else {
        if (
          this.$route.query.status === 1 ||
          this.$route.query.status === '1'
        ) {
          let nowDate = new Date(
            dayjs(new Date()).format('YYYY-MM-DD') + ' 00:00:00'
          ).getTime()
          if (new Date(val).getTime() < nowDate) {
            this.$message({
              type: 'error',
              message: '执行时间必须大于当下时间',
              showClose: true
            })
            this.date = ''
          }
        }
      }
    }
  },
  created () {
    if (this.$route.query.id) {
      this.getDetail()
      if (this.$route.query.status === 1 || this.$route.query.status === '1') {
        this.handleShow = true
      } else {
        this.handleShow = false
      }
      this.titleMsg = '任务详情'
    } else {
      this.titleMsg = '创建传播任务'
    }
  },
  methods: {
    handleStr (str) {
      // if (str.length > 5) {
      //   return str.substring(0, 5) + '...'
      // } else {
      //   return str
      // }
      return str
    },
    async getDetail () {
      const res = await BIZAPIS.SpreadtaskApi.yqfSpreadtaskDetailGet({
        _id: this.$route.query.id
      })
      if (res.success) {
        this.list = res.data.formMeta
        this.date = res.data.startTime
      }
    },
    goBack () {
      this.$router.go(-1)
    },
    addMaketingData (data) {
      // 添加营销资料
      this.list.push(data)
    },
    replaceMaketingData (data) {
      // 更新营销资料
      this.list[this.editIndex] = {
        _id: data._id,
        title: data.title,
        tags: data.tags,
        materialType: data.materialType
      }
    },
    addMaterial () {
      if (this.list.length >= 10) {
        this.$message({
          type: 'error',
          message: '最多添加10条',
          showClose: true
        })
      } else {
        this.state = 0
        this.show = true
      }
    },
    cancel () {
      this.show = false
    },
    edit (index, id) {
      this.editIndex = index
      this.selectedId = id
      this.state = 1
      this.show = true
    },
    remove (index, id) {
      this.removeIndex = index
      this.list.splice(index, 1)
    },
    confirm () {
      if (this.verificate()) {
        if (this.$route.query.id) {
          this.replaceTask()
        } else {
          this.addTask()
        }
      }
    },
    async addTask () {
      const res = await BIZAPIS.SpreadtaskApi.yqfSpreadtaskCreatePost({
        startTime: this.date,
        formData: this.formData
      })
      if (res.success) {
        this.$message({
          type: 'success',
          message: '创建成功',
          showClose: true
        })
        this.$router.go(-1)
      } else {
        this.$message({
          type: 'error',
          message: res.msg,
          showClose: true
        })
      }
    },
    async replaceTask () {
      const res = await BIZAPIS.SpreadtaskApi.yqfSpreadtaskUpdatePost({
        _id: this.$route.query.id,
        formData: this.formData,
        startTime: this.date
      })
      if (res.success) {
        this.$message({
          type: 'success',
          message: '更新成功',
          showClose: true
        })
      } else {
        this.$message({
          type: 'error',
          message: res.msg,
          showClose: true
        })
      }
    },
    verificate () {
      // 验证
      if (this.date) {
        if (this.list.length > 0) {
          return true
        } else {
          this.$message({
            type: 'error',
            message: '请添加分享内容',
            showClose: true
          })
        }
      } else {
        this.$message({
          type: 'error',
          message: '请选择日期',
          showClose: true
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
body {
  .new-task {
    height: 100%;
    display: flex;
    flex-direction: column;

    /deep/.el-date-editor--date {
      width: 140px;
      height: 32px;

      .el-input__inner {
        width: 140px;
        height: 32px;
      }
    }

    /deep/ .el-input__prefix {
      .el-icon-date {
        line-height: 32px;
      }
    }

    /deep/ .el-input__icon {
      line-height: 32px;
    }

    /deep/ .new-btn {
      padding: 0 14px !important;
      border-radius: 4px;

      .el-icon-search {
        font-size: 14px;
      }

      span {
        font-size: 13px;
        margin-left: 4px;
      }
    }

    .header {
      width: 100%;
      height: 60px;
      box-sizing: border-box;
      box-shadow: 0 -1px 0 0 #e8e8e8 inset;
      display: flex;
      align-items: center;
      flex-shrink: 0;

      .go-back {
        height: 100%;
        padding: 0 8px 0 20px;
        cursor: pointer;
        display: flex;
        align-items: center;

        .icon {
          color: #000;
          font-size: 20px;
          font-weight: 500;
        }
      }

      .txt {
        font-weight: 500;
        font-size: 16px;
        line-height: 60px;
      }
    }

    .search {
      width: calc(100% - 40px);
      margin: 0 auto;
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-shrink: 0;

      .date {
        display: flex;
        align-items: center;

        .icon {
          color: red;
        }

        .txt {
          font-size: 13px;
          color: #262626;
          margin-right: 8px;
        }

        .date-txt {
          font-size: 13px;
          color: #262626;
        }
      }
    }

    .content {
      width: calc(100% - 40px);
      margin: 0 auto;
      height: 100%;
      // max-height: 400px;
      margin-bottom: 60px;
      overflow: auto;

      .list {
        border: 1px solid #e8e8e8;

        .list-item {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #e8e8e8;

          .list-item-main {
            display: flex;
            margin: 16px 0 16px 20px;

            .index {
              font-size: 13px;
              line-height: 18px;
              color: #595959;
              margin-right: 20px;
              font-weight: 500;
            }

            .content-c-t {
              font-size: 13px;

              .title {
                color: #009cff;
                // font-weight: 500;
              }
            }

            .content-c-tag {
              color: #888;
              font-size: 13px;
              font-weight: normal;
              margin-top: 12px;
              display: flex;
              align-items: center;

              .tag-group {
                .tag-item {
                  margin-right: 8px;
                  padding: 0 8px;
                  font-size: 12px;
                  height: 22px;
                  line-height: 22px;
                  background-color: #ebeff4;
                  color: #6b7b88;
                }
              }
            }
          }

          .list-item-handle {
            margin: 6px 20px 0 0;
          }
        }

        .list-item:last-child {
          border: none;
        }
      }
    }

    .handle {
      display: flex;
      height: 56px;
      box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
  }

  & /deep/ .task-list-add-tag-popper {
    .all-tags {
      max-width: 200px;

      .tag-item {
        margin: 5px 0 0 5px !important;
        padding: 0 8px;
        font-size: 12px;
        height: 22px;
        line-height: 22px;
        background-color: #ebeff4;
        color: #6b7b88;
      }
    }
  }
}

</style>
